// Generated by GitHub Copilot
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';
import styles from './ClientStories.module.css';
import fedexLogo from '../../assets/images/Logo Picture Fedex Free HD Image Transparent HQ PNG Download _ FreePNGimg.png';
import telstraLogo from '../../assets/images/Telstra new logo transparent PNG - StickPNG.jpg';
import bmsLogo from '../../assets/images/Bristol Myers Squibb (BMS) _ United Kingdom - SciPro.png';
import ecolabLogo from '../../assets/images/Ecolab.jpg';
import AILedImage1 from '../../assets/images/AI‑Led-GCC-Transformation-image1.jpg';
import AILedImage2 from '../../assets/images/AI‑Led-GCC-Transformation-image2.jpg';
import GlobalAIImage1 from '../../assets/images/Global-AI-Joint-Venture-Launch-image1.png';
import GlobalAIImage2 from '../../assets/images/Global-AI-Joint-Venture-Launch-image2.jpg';
import GenAIImage1 from '../../assets/images/GenAI-Content-Hub-image1.jpg';
import GenAIImage2 from '../../assets/images/GenAI-Content-Hub-image2.jpg';
import GenAIImage3 from '../../assets/images/GenAI-Content-Hub-image3.jpg';

const CLIENT_STORIES = [
  {
    slug: 'fedex',
    logo: fedexLogo,
    logoAlt: 'FedEx logo',
    title: 'AI‑Led GCC Transformation',
    description: (
      <>
        FedEx opened its Hyderabad Advanced
        Capability Community to tap India&apos;s tech talent and accelerate digital innovation. As
        FedEx moved toward AI-powered operations, Accenture used{' '}
        LearnVantage to deliver role-based AI
        education, live training and skilling
        pathways for responsible adoption at scale.
      </>
    ),
    imageLayout: 'duo',
    images: [AILedImage1, AILedImage2],
    imageAlts: ['AI-Led GCC Transformation highlight 1', 'AI-Led GCC Transformation highlight 2'],
  },
  {
    slug: 'telstra',
    logo: telstraLogo,
    logoAlt: 'Telstra logo',
    title: 'Global AI Joint Venture Launch',
    description: (
      <>
        Telstra wanted to turn hundreds of AI
        ideas into enterprise value across networks, customer{' '}
        experience and operations. Accenture
        responded with a proposed{' '}
        seven-year global AI joint venture to
        modernize data and AI platforms,{' '}
        embed responsible AI, build agentic-AI tools and raise AI fluency.
      </>
    ),
    imageLayout: 'duo',
    images: [GlobalAIImage1, GlobalAIImage2],
    imageAlts: ['Global AI Joint Venture Launch highlight 1', 'Global AI Joint Venture Launch highlight 2'],
  },
  {
    slug: 'bms',
    logo: bmsLogo,
    logoAlt: 'Bristol Myers Squibb logo',
    title: 'GenAI Content Hub',
    description: (
      <>
        Bristol Myers Squib needed faster, more
        personalized content for healthcare professionals. Accenture helped launch Mosaic in Mumbai,
        an{' '}
        end-to-end generative AI content hub that identifies physician education{' '}
        needs in real time and combines creative-tech teams to deliver tailored, patient-centric
        content at scale.
      </>
    ),
    imageLayout: 'magazine',
    images: [GenAIImage1, GenAIImage3],
    imageAlts: ['GenAI Content Hub hero image', 'GenAI Content Hub highlight 2', 'GenAI Content Hub highlight 3'],
  },
  {
    slug: 'ecolab',
    logo: ecolabLogo,
    logoAlt: 'Ecolab logo',
    title: 'GCC-Led Talent Hub',
    description: (
      <>
        Ecolab&apos;s GBS 1.0 was limited to
        F&amp;A transactions, fragmented across EU/NA divisions, and{' '}
        failing to deliver full value.
        Accenture helped design a multi-function GBS 2.0 platform - spanning Finance, HR, IT,
        Procurement, and Sales Ops - with a{' '}
        vision, operating model blueprint, global delivery network strategy, and a quantified
        value case{' '}
        to reset costs and enable scalable growth.
      </>
    ),
    ctaUrl: 'https://mediaexchange.accenture.com/media/t/1_kaab8h05',
    ctaLabel: 'Check the conversation here',
  },
];

const ClientStories = () => {
  const navigate = useNavigate();
  const [popupImage, setPopupImage] = useState(null);

  // Close on Escape key
  useEffect(() => {
    if (!popupImage) return;
    const handleKey = (e) => { if (e.key === 'Escape') setPopupImage(null); };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [popupImage]);

  // Lock body scroll when popup is open
  useEffect(() => {
    document.body.style.overflow = popupImage ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [popupImage]);

  return (
    <div className={styles.page}>
      <Navbar />
      <div className={styles.heroPadding} />

      {/* ── Back button bar ── */}
      <div className={styles.backBar}>
        <button
          type="button"
          onClick={() => navigate(-1)}
          className={styles.backButton}
          aria-label="Go back to previous page"
        >
          <svg className={styles.backIcon} fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
          Back
        </button>
      </div>

      {/* ── Hero Section ── */}
      <section className={styles.heroSection} aria-labelledby="client-stories-heading">
        {/* Bokeh background blobs */}
        <div aria-hidden="true" className={styles.bokehContainer}>
          <div className={styles.blobLeft} />
          <div className={styles.blobCenter} />
          <div className={styles.blobRight} />
        </div>

        <div className={styles.heroContent}>
          <p className={styles.eyebrow}>CLIENT STORIES</p>
          <h1 id="client-stories-heading" className={styles.heroHeading}>
            Flagship Client Stories
          </h1>
          <p className={styles.heroSubtext}>
            See how organizations are using GCCs to unlock talent, accelerate transformation and
            turn operational capability into enterprise-wide value.
          </p>
        </div>
      </section>

      {/* ── Cards Section ── */}
      <section className={styles.cardsSection} aria-label="Client story cards">
        <div className={styles.cardsGrid}>
          {CLIENT_STORIES.map((card) => (
            <article key={card.slug} className={styles.card} aria-label={`${card.logoAlt}: ${card.title}`}>

              {/* Top accent bar */}
              <div className={styles.cardAccentBar} aria-hidden="true" />

              {/* Logo */}
              <div className={styles.cardHeader}>
                <div className={styles.cardLogoWrap}>
                  <img src={card.logo} alt={card.logoAlt} className={styles.cardLogo} />
                </div>
              </div>

              {/* Title + description */}
              <div className={styles.cardBody}>
                <h2 className={styles.cardTitle}>{card.title}</h2>
                <p className={styles.cardDesc}>{card.description}</p>
              </div>

              {/* Thumbnails + CTA */}
              <div className={styles.cardFooter}>
                {card.images && (
                  <div className={styles.cardThumbs}>
                    {card.images.slice(0, 2).map((img, i) => (
                      <button
                        key={i}
                        type="button"
                        className={styles.cardThumb}
                        onClick={() => setPopupImage(img)}
                        aria-label={`Enlarge ${card.imageAlts[i]}`}
                      >
                        <img src={img} alt={card.imageAlts[i]} className={styles.cardThumbImg} />
                        <span className={styles.cardImageZoomHint} aria-hidden="true">&#x1F50D;</span>
                      </button>
                    ))}
                  </div>
                )}
                {card.ctaUrl && (
                  <a
                    href={card.ctaUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.cardCta}
                    aria-label={`${card.ctaLabel} for ${card.title} (opens in a new tab)`}
                  >
                    {card.ctaLabel} &rsaquo;
                  </a>
                )}
              </div>

            </article>
          ))}
        </div>
      </section>

      <Footer />

      {/* ── Lightbox popup ── */}
      {popupImage && (
        <div
          className={styles.popupOverlay}
          onClick={() => setPopupImage(null)}
          role="dialog"
          aria-modal="true"
          aria-label="Image lightbox"
        >
          <button
            type="button"
            className={styles.popupClose}
            onClick={() => setPopupImage(null)}
            aria-label="Close image"
          >
            &times;
          </button>
          <img
            src={popupImage}
            alt="Enlarged view"
            className={styles.popupImage}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
};

export default ClientStories;
